export const filterUrl = (value: string) => {
  let url = `/${value}`;
  url = url.replace('//', '/');
  return url;
};
